import { BaseModalProps, LabelValueRow, Modal, OperationButton } from '@/components/core-v2'
import { CURRENCY } from '@/const'
import { formatCurrencyFull } from '@/utilities/currency'

import classes from './index.module.scss'

export interface TransferSwitchModalProps extends BaseModalProps {
  amount: number
  from: string
  isLoading: boolean
  submit: () => void
  to: string
}

export const TransferSwitchModal = (props: TransferSwitchModalProps) => {
  const { amount, from, isLoading, isOpen, onClose, submit, to } = props
  return (
    <Modal.Wrapper
      aria-labelledby="transfer-switch-modal-label"
      className={classes.switchModal}
      isOpen={isOpen}
      width="sm"
      onClose={onClose}
    >
      <Modal.Body>
        <h2>Please review a summary of this switch</h2>
        <p>Once the switch has been submitted, it cannot be undone</p>
        <LabelValueRow label="Switching from" value={from} />
        <LabelValueRow label="Switching to" value={to} />
        <LabelValueRow label="Amount" value={formatCurrencyFull(amount, CURRENCY)} />
        <div className={classes.buttons}>
          <OperationButton
            isLoading={isLoading}
            operationType="progress"
            type="button"
            onClick={submit}
          >
            Submit switch
          </OperationButton>
          <OperationButton
            isLoading={isLoading}
            operationType="neutral"
            type="button"
            onClick={onClose}
          >
            Cancel
          </OperationButton>
        </div>
      </Modal.Body>
    </Modal.Wrapper>
  )
}
